import "./PagesHeader.scss";

const ComponentHeader = ({ title }) => {
  return <h1 className="page-title">{title}</h1>;
};

export default ComponentHeader;
